import { tenvideo, env } from '@tencent/vft-common';
import IconShare from '@tencent/vft-component/IconShare';
import Vue from 'vue';
IconShare.install(Vue);
export default {
  name: 'PicShareModal',
  props: {
    base64: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      env: env,
      isApp: true
    };
  },
  computed: {
    isAdvancedApp: function isAdvancedApp() {
      // 6.0以上app
      return env.isApp && tenvideo.versionCompare(tenvideo.getVersion(), '6.0.0');
    },
    isRightCornerShow: function isRightCornerShow() {
      return env.isMqq || env.isWechat;
    },
    canAppShareImg: function canAppShareImg() {
      return env.isApp && !env.isIpad;
    },
    isGenerated: function isGenerated() {
      return this.base64 !== '';
    }
  },
  methods: {
    hide: function hide() {
      this.$emit('hide');
    },
    shareLocalImg: function shareLocalImg() {
      var _this = this;

      if (tenvideo.isTenvideo()) {
        if (!this.isAdvancedApp) {
          this.loading.show('', 6000);
        }

        if (this.base64) {
          tenvideo.shareLocalImage(this.base64, function (res) {
            window.console.log(res);

            _this.loading.hide();

            _this.$emit('share');
          }, function (err) {
            window.console.error(err);
          });
        } else {
          this.toast('正在抓紧生成中，稍后点击');
        }
      }
    }
  }
};